import React from 'react'
import { SortDescriptor } from '@progress/kendo-data-query/dist/npm/sort-descriptor'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'
import { IbContestInternalResultsKey } from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import { SortLogic } from 'utils/QueryHelpers'

import campaignDetailsResultsColumn from './campaignDetailsResultsColumn'
import { CampaignDetailsResultsPage } from './CampaignDetailsResultsPage'
import { normalizeIBContestSortQuery } from './normalizeIBContestSortQuery'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

const sortQuery: SortDescriptor[] = [
  {
    field: IbContestInternalResultsKey.ranking,
    dir: SortLogic.ASC,
  },
]

export const CampaignIbContestDetailsResultsPage: React.FC<OuterProps> = ({ data }) => {
  return (
    <CampaignDetailsResultsPage
      data={data}
      columns={campaignDetailsResultsColumn}
      sortQuery={sortQuery}
      normalizeSortQuery={normalizeIBContestSortQuery}
    />
  )
}
